<template>
	<div>
		<CCard>
			<CCardHeader> Historique des créations des bordereaux </CCardHeader>
			<CCardBody>
				<GDataTableRemote
					ref="mainTable"
					remote-url="/api/slip_histories"
					:fields="fields"
					:items-per-page="10"
					hover
					striped
					sorter
					columnFilter
					pagination>
					<template #actions="{ item }">
						<td class="text-center">
							<a class="text-center icon-space" href="#" @click="download(item)">
								<CIcon name="cil-print" />
							</a>
						</td>
					</template>
				</GDataTableRemote>
			</CCardBody>
		</CCard>
	</div>
</template>

<script>
	import GDataTableRemote from '../../../components/ghostlexly-components/GDataTableRemote';
	export default {
		name: 'history.vue',

		components: {
			GDataTableRemote,
		},

		data() {
			return {
				fields: [
					{ key: 'createdAt', label: 'Date de création', type: 'daterange' },
					{ key: 'pointOfSale.name', label: 'Nom du point de vente' },
					{ key: 'count', label: 'Nombre de bons' },
					{ key: 'createdBy.email', label: 'Créé par' },
					{ key: 'actions', filter: false },
				],
			};
		},

		methods: {
			download: function (item) {
				this.$axios
					.get(`/api/slip_histories/print/${item.id}`, { responseType: 'blob' })
					.then(res => {
						if (res.status === 200 || res.status === 201) {
							let filename = res.headers['content-disposition'];
							filename = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(filename);
							if (filename != null && filename[1]) {
								filename = filename[1].replace(/['"]/g, '');
							} else {
								filename = 'file.pdf';
							}

							const url = window.URL.createObjectURL(new Blob([res.data]));
							const link = document.createElement('a');
							link.href = url;
							link.setAttribute('download', filename); //or any other extension
							document.body.appendChild(link);
							link.click();
						}
					})
					.catch(err => {
						new Blob([err.response.data]).text().then(data => {
							data = JSON.parse(data);
							this.$toast.error(data['hydra:description']);
						});
					});
			},
		},
	};
</script>
